
const digest = 'cd768b4e1529d2bac3ec5b5d89f886a214d14b7e750c3b7e8537447c7024e9df';
const classes = {"wrapper":"_wrapper_8pjwx_1"};
const css = `._wrapper_8pjwx_1 {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-bottom: 1px solid #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  